export default __webpack_public_path__ + "eef74bf01b958d1b513c7d4212d8f434.svg";